import { getPathnameItem, parseSearch } from "helpers/inventory-filters";
import { showFilterChip } from "helpers/search-filter-helpers";
import { useRouter } from "next/router";
import cloneDeep from "lodash/cloneDeep";

const rangedFilters = ["year", "kilometers", "price"];

/**
 * @description Returns an object with key value pairs where the key is the name of an
 * inventory filter and the value is an array of the filters present in pathname and search params,
 * and then a second param with a true/false depicting whether or not the filter menu should drop
 * based on ignored keys.
 *
 * @param {string} pathname   Url
 * @param {string} search     Search params containing inventory filter
 *                            and the value (eg. ?year=1969)
 *
 * Object with properties containing the filters and their values
 * @returns {filters: Object, }
 */
function useInventoryFilters(ignoreKeys = []) {
  const router = useRouter();
  let filterCount = 0;
  const baseFilters = {
    make: [],
    model: [],
    bodyType: [],
    condition: [],
    price: [],
    kilometers: [],
    year: [],
    exteriorColour: [],
    interiorColour: [],
    transmission: [],
    fuelType: [],
    driveType: [],
    lifestyle: [],
    dealershipId: [],
    sellerType: [],
  };
  const mainFilters = {
    make: getPathnameItem(router.query.slug, "make")
      ? [getPathnameItem(router.query.slug, "make")]
      : [],
    model: getPathnameItem(router.query.slug, "model")
      ? [getPathnameItem(router.query.slug, "model")]
      : [],
  };
  const queryCopy = cloneDeep(router.query);
  delete queryCopy.slug;
  const secondaryFilters = parseSearch(queryCopy);
  // If there is a year in the pathname and not in the search, add a year filter here
  if (!secondaryFilters.year && getPathnameItem(router.query.slug, "year")) {
    mainFilters.year = [
      getPathnameItem(router.query.slug, "year"),
      getPathnameItem(router.query.slug, "year"),
    ];
  }
  const allFilters = { ...baseFilters, ...secondaryFilters, ...mainFilters };
  ignoreKeys.forEach((key) => {
    delete allFilters[key];
  });
  const chipFilters = {};
  Object.keys(allFilters).forEach((key) => {
    if (showFilterChip(key) && allFilters[key].length > 0)
      chipFilters[key] = allFilters[key];
  });
  Object.keys(chipFilters).forEach((key) => {
    if (rangedFilters.includes(key)) {
      filterCount += 1;
    } else {
      filterCount += chipFilters[key].length;
    }
  });

  return {
    filters: allFilters,
    filterCount,
  };
}

export default useInventoryFilters;
